import { render, staticRenderFns } from "./EfficiencyTestsModelDefinition.vue?vue&type=template&id=35d9c6ba&scoped=true"
import script from "./EfficiencyTestsModelDefinition.vue?vue&type=script&lang=js"
export * from "./EfficiencyTestsModelDefinition.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyTestsModelDefinition.vue?vue&type=style&index=0&id=35d9c6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9c6ba",
  null
  
)

export default component.exports